import "./input.scss";
import ErrorTooltip from "components/ErrorTooltip/ErrorTooltip";

function OutlinedInput({
  label,
  placeholder,
  onChange,
  appendIcon,
  wrapperClass,
  error = null,
  errorVariant,
  ...rest
}) {
  return (
    <>
      <div>
        <label htmlFor=""></label>
        {error && <ErrorTooltip errorVariant={errorVariant} text={error} />}
      </div>
      <div className={`outlinedInput__input_wrapper ${wrapperClass}`}>
        <label
          aria-hidden="true"
          className="outlinedInput__input_label"
          htmlFor=""
        >
          {label}
        </label>
        <input
          placeholder={placeholder}
          type="text"
          className="outlinedInput__input"
          {...rest}
        />
        {appendIcon}
      </div>
    </>
  );
}

export default OutlinedInput;
